import { render, staticRenderFns } from "./SendEventModal.vue?vue&type=template&id=1d2cc9ce&scoped=true&"
import script from "./SendEventModal.vue?vue&type=script&lang=js&"
export * from "./SendEventModal.vue?vue&type=script&lang=js&"
import style0 from "./SendEventModal.vue?vue&type=style&index=0&id=1d2cc9ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2cc9ce",
  null
  
)

export default component.exports